import store from "@/store";
import {NextStepRequired} from "@/domain/autologin/exceptions";

export default [
    {
        path: '/complete-checkin',
        name: 'complete-checkin',
        component: () => import(/* webpackChunkName: "checkins-confirm" */ '../views/CheckinsComplete.vue'),
        meta: {
            requiresAuth: true
        },
        beforeEnter: async (to, from, next) => {
            if (to.query.hasOwnProperty('t')) {
                store.commit('checkin/set_token', to.query.t)
                try {
                    const response = await store.dispatch('checkin/completeCheckin', {})
                    next({name: 'checkins-detail', params: {picacode: response.data.picacode}})
                }
                catch (e) {
                    if (e instanceof NextStepRequired) {
                        next()
                        await store.dispatch('checkin/openStepModal')
                    } else {
                        throw e
                    }
                }
            } else {
                // se non c'è il token, mostro il componente che dirà 'link non valido'
                next()
            }
        },
    },
    {
        path: '/checkins/:picacode',
        name: 'checkins-detail',
        component: () => import(/* webpackChunkName: "checkins-detail" */ '../views/CheckinsDetail.vue'),
        meta: {
            requiresAuth: true,
            showCheckoutBanner: false,
            showBackButton: true,
            showCheckinMenu: true
        },
    },
    {
        path: '/checkin-error',
        name: 'checkin-error',
        component: () => import(/* webpackChunkName: "checkins-error" */ '../domain/checkin/CheckinError.vue'),
        meta: {
            requiresAuth: true,
        },
    }
]

